import React, {useState, useRef, useEffect} from "react";
import {useStyles} from "./styles/OddStepSevenStyle";
import {
    Box,
    Button,
    Typography,
    Tabs,
    Tab,
    IconButton,
    FormControl, Popover, Select, MenuItem
} from "@material-ui/core";
import PropTypes from 'prop-types';
import clsx from "clsx";
import { ReactComponent as VolumeDisableIcon } from '../../../../../common/images/VolumeDisableIcon.svg';
import { ReactComponent as VolumeIcon } from '../../../../../common/images/VolumeIcon.svg';
import { ReactComponent as Refresh } from '../../../../../common/images/Refresh.svg';
import { ReactComponent as RefreshDisabled } from '../../../../../common/images/RefreshDisabled.svg';
import { ReactComponent as ArrowDownIcon } from '../../../../../common/images/ArrowDownIcon.svg';

import NoImage from '../../../../../common/images/NoImage.jpg';
import OddStepSevenDivide from "./OddStepSevenDivide";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";
import {ReactComponent as TooltipTipIcon} from "../../../../../common/images/TooltipTipIcon.svg";
import {ReactComponent as TooltipClose} from "../../../../../common/images/TooltipClose.svg";
import AudioPlayer from "../../../../../components/AudioPlayer";
import {ReactComponent as CheckPointIcon} from "../../../../../common/images/CheckPointIcon.svg";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function OddStepSeven(props) {
    const classes = useStyles();

    const {contentStore,oddStepSevenStore,oddStepTwoStore,audioPlayerStore} = props;
    const {stepValue, dayValue} = props.contentStore;

    const anchorElRef = useRef(null);
    const anchorPositionElRef = useRef(null);
    const imageRef = useRef(null);

    const handleChange = (event, newValue) => {
        oddStepSevenStore.setContentTapIndex(newValue);
    };

    const onSave = () => {
        oddStepSevenStore.modifyOddStepSevenContent(stepValue, dayValue, () => {
            oddStepSevenStore.getOddStepSevenContent(stepValue,dayValue, processOddStepSevenContent);
            contentStore.setReadyToSaveStep(false);
        });
    }

    const processOddStepSevenContent = (res) => {
        const isCompleted = oddStepSevenStore.isOddStepSevenCompleted(res);
        contentStore.setReadyToMoveExit(isCompleted);
    }

    useEffect(() => {
        oddStepSevenStore.getOddStepSevenContent(stepValue,dayValue, processOddStepSevenContent)
        oddStepTwoStore.setSelectedContent();
        setTimeout(() => {
            oddStepTwoStore.setSelectedSubContent(2);
            oddStepTwoStore.setPositionList();
        },1000);
        props.contentStore.setOnSave(onSave);
        return ()=> {
            props.contentStore.setOnSave(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        window.addEventListener('dragover', handleDragOver);

        return () => {
            window.addEventListener('dragover', handleDragOver);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 툴팁
    const [anchorEl, setAnchorEl] = useState(0);

    const handleOpenPopover = () => {
        setAnchorEl(anchorElRef.current);
        oddStepSevenStore.setPopoverState(true);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
        oddStepSevenStore.setPopoverState(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;


    const [anchorPositionEl, setAnchorPositionEl] = useState(0);

    const handleOpenPositionPopover = () => {
        setAnchorPositionEl(anchorPositionElRef.current);
        oddStepSevenStore.setPositionPopoverState(true);
    };

    const handleClosePositionPopover = () => {
        setAnchorPositionEl(null);
        oddStepSevenStore.setPositionPopoverState(null);
    };
    const positionOpen = Boolean(anchorPositionEl);
    const positionId = positionOpen ? 'simple-position-popover' : undefined;


    const handleClickDivide = () => {
        oddStepSevenStore.setIsProcessing(true);
        oddStepSevenStore.resetTempContentList();
        handleOpenPopover();
    }

    const handleFinishDivide = () => {
        oddStepSevenStore.setIsProcessing(false);
        oddStepSevenStore.savePieceListTextIndex();
        contentStore.setReadyToSaveStep(oddStepSevenStore.isChangeContent());
    }

    const handleClickAudio = (id, startTime, endTime) => {
        oddStepSevenStore.playAudio(id, startTime, endTime);
    }

    const handleClickPieceAudio = (id, piece) => {
        if (piece.audioStartTime !== null) {
            oddStepSevenStore.playAudio(id, piece.audioStartTime, piece.audioEndTime);
        } else {
            if (piece.audio === undefined) {
                oddStepSevenStore.getPieceAudio(piece, (pieceAudio) => oddStepSevenStore.playPieceAudio(pieceAudio));
            } else {
                oddStepSevenStore.playPieceAudio(piece.audio);
            }
        }
    }

    const handleClickGenerateSound = () => {
        oddStepSevenStore.stopAudio();
        audioPlayerStore.setAudioRegionList([]);
        audioPlayerStore.setIsOpen(true);
    }

    const handleCloseGenerateSound = () => {
        audioPlayerStore.setIsProcessing(false);
        audioPlayerStore.setSelectedAudioRegion(null);
    }

    const handleFinishGenerateSound = () => {
        oddStepSevenStore.setSubContentAudios(audioPlayerStore.audioRegionList);
        contentStore.setReadyToSaveStep(true);
    }

    const handleClickGeneratePosition = () => {
        oddStepSevenStore.setIsPositionProcessing(true);
        oddStepSevenStore.resetTempContentList();
        handleOpenPositionPopover();
    }

    const handleClickRandomPosition = () => {
        oddStepSevenStore.setRandomPosition();
    }

    const handleFinishPosition = () => {
        oddStepSevenStore.setIsPositionProcessing(false);
        oddStepSevenStore.savePieceListPosition();
        contentStore.setReadyToSaveStep(oddStepSevenStore.isChangeContent());
    }

    const handleImageLoad = () => {
        oddStepSevenStore.resetTempContentList();
    }

    const getPosition = (seq) => {
        const imageRect = imageRef.current.getBoundingClientRect();
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;

        const oneWidth = imageWidth / 3;
        const oneHeight = imageHeight / 3;

        let left = 0;
        let top = 0;

        if (seq % 3 === 1) {
            left = oneWidth / 2;
        } else if (seq % 3 === 2) {
            left = oneWidth + (oneWidth / 2);
        } else if (seq % 3 === 0) {
            left = oneWidth * 2 + (oneWidth / 2);
        }

        if (seq / 3 <= 1) {
            top = oneHeight / 2;
        } else if (seq / 3 <= 2) {
            top = oneHeight + (oneHeight / 2);
        } else if (seq / 3 <= 3) {
            top = oneHeight * 2 + (oneHeight / 2);
        }

        return {left: left, top: top};
    }

    const getPrevPosition = (x, y) => {
        const imageRect = imageRef.current.getBoundingClientRect();

        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;

        const xPosition = imageWidth * x / 100;
        const yPosition = imageHeight * y / 100;

        return {
            x: xPosition,
            y: yPosition
        }
    }


    const getPositionSeq = (eventX, eventY) => {
        const imageRect = imageRef.current.getBoundingClientRect();
        const imageWidth = imageRef.current.width;
        const imageHeight = imageRef.current.height;
        const x = eventX - imageRect.left;
        const y = eventY - imageRect.top;
        const oneWidth = imageWidth / 3;
        const oneHeight = imageHeight / 3;

        if (x > 0 && x < oneWidth && y > 0 && y < oneHeight) {
            return 1;
        } else if (x > oneWidth && x < oneWidth * 2 && y > 0 && y < oneHeight) {
            return 2;
        } else if (x > oneWidth && x < oneWidth * 3 && y > 0 && y < oneHeight) {
            return 3;
        } else if (x > 0 && x < oneWidth && y > oneHeight && y < oneHeight * 2) {
            return 4;
        } else if (x > oneWidth && x < oneWidth * 2 && y > oneHeight && y < oneHeight * 2) {
            return 5;
        } else if (x > oneWidth * 2 && x < oneWidth * 3 && y > oneHeight && y < oneHeight * 2) {
            return 6;
        } else if (x > 0 && x < oneWidth && y > oneHeight * 2 && y < oneHeight * 3) {
            return 7;
        } else if (x > oneWidth && x < oneWidth * 2 && y > oneHeight * 2 && y < oneHeight * 3) {
            return 8;
        } else if (x > oneWidth * 2 && x < oneWidth * 3 && y > oneHeight * 2 && y < oneHeight * 3) {
            return 9;
        }
    }

    const handleResize = () => {
        if (imageRef.current) {
            const imageWidth = imageRef.current.width;
            const imageHeight = imageRef.current.height;

            if (imageWidth === 0 || imageHeight === 0) {
                return;
            }

            const positionElList = document.querySelectorAll('[id^="position-"]');
            for (const positionEl of positionElList) {
                const imageSeq = positionEl.id.split('-')[1];
                const position = getPosition(imageSeq);

                positionEl.style.left = `${position.left}px`;
                positionEl.style.top = `${position.top}px`;
            }

            oddStepTwoStore.positionList.forEach((position, index) => {
                const x = (position.x / 100) * imageWidth;
                const y = (position.y / 100) * imageHeight;
                const element = document.getElementById(`position-${index}`);

                if (element) {
                    element.style.left = `${x}px`;
                    element.style.top = `${y}px`;
                }
            });
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleResetPosition = () => {
        oddStepSevenStore.resetPosition();
    }

    const existPositionIndex = (seq) => {
        const existIndex = selectedTempContent.pieces.findIndex(p => p.imageSequence === seq);
        return existIndex !== -1;
    }

    const generatePosition = (event) => {
        if (oddStepSevenStore.isPositionProcessing) {
            if (selectedTempContent.pieces.every(piece => piece.imageSequence !== null)) {
                for (const piece of selectedTempContent.pieces) {
                    oddStepSevenStore.setPieceImageSeq(piece, null);
                }
            }
            for (const piece of selectedTempContent.pieces) {
                if (!piece.imageSequence) {
                    const positionSeq = getPositionSeq(event.clientX, event.clientY);
                    if (!existPositionIndex(positionSeq)) {
                        oddStepSevenStore.setPieceImageSeq(piece, positionSeq);
                    }
                }
            }
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    }

    const handleDrag = (event) => {
        if (oddStepSevenStore.isPositionProcessing) {
            const imageSeq = event.target.id.split('-')[1];
            const piece = selectedTempContent.pieces.find(p => p.imageSequence === Number(imageSeq));

            if (piece) {
                const positionSeq = getPositionSeq(event.clientX, event.clientY);
                if (!existPositionIndex(positionSeq) && positionSeq) {
                    oddStepSevenStore.setPieceImageSeq(piece, positionSeq);
                }
            }
        }
    }

    const selectedContent = oddStepSevenStore.contentList ? oddStepSevenStore.getSelectedContent() : null;
    const selectedTempContent = oddStepSevenStore.tempContentList ? oddStepSevenStore.getSelectedTempContent() : null;

    return (
        <Box className={classes.root}>
            <Box display={"flex"} justifyContent={"flex-first"}>
                <Box className={clsx(classes.boxWrap, classes.heightStep1)}>
                    <Box>
                        <Box position="static" className={classes.tabBox}>
                            <Tabs value={oddStepSevenStore.contentTapIndex} onChange={handleChange} aria-label="simple tabs example">
                                <Tab label="한국어" {...a11yProps(0)} disableRipple/>
                                <Tab label="영어" {...a11yProps(1)} disableRipple/>
                                <Tab label="일본어" {...a11yProps(2)} disableRipple/>
                                <Tab label="중국어" {...a11yProps(3)} disableRipple/>
                            </Tabs>
                        </Box>
                        {Array.from({length: 4}, (_, i) => {
                            const content = oddStepSevenStore.contentList && oddStepSevenStore.getContent(i);
                            const tempContent = oddStepSevenStore.contentList && oddStepSevenStore.getTempContent(i);
                            return (
                                <TabPanel key={i} value={oddStepSevenStore.contentTapIndex} index={i} className={classes.textBox}>
                                    <Box >
                                        <Box display={"flex"} justifyContent={"flex-first"} alignItems={"center"} sx={{marginBottom: 10}}>
                                            <FormControl className={classes.formControl}>
                                                <Select
                                                    disabled={true}
                                                    value={content ? content.voiceType : 'Man'}
                                                    IconComponent={(props) => (
                                                        <Box>
                                                            <ArrowDownIcon  {...props} />
                                                        </Box>
                                                    )}
                                                    MenuProps={{
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "right"
                                                        },
                                                        transformOrigin:{
                                                            vertical: 'top',
                                                            horizontal: 'right',
                                                        },
                                                        getContentAnchorEl: null,
                                                        className:classes.selectPopover
                                                    }}
                                                >
                                                    <MenuItem value='Man'>성인남성</MenuItem>
                                                    <MenuItem value='Woman'>성인여성</MenuItem>
                                                    <MenuItem value='Child'>아이</MenuItem>
                                                    <MenuItem value='Elderly'>노인</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box className={classes.textCutBox} ref={anchorElRef}>
                                            {oddStepSevenStore.isProcessing ?
                                                <OddStepSevenDivide content={tempContent}/>
                                                :
                                                <>
                                                    <Typography>{content && content.text}</Typography>
                                                    <IconButton className={classes.volumeIconPosition} disableRipple style={{cursor: selectedContent && selectedContent.audio === null ? 'default' : 'pointer'}} onClick={() => handleClickAudio('main')}>
                                                        {selectedContent && selectedContent.audio !== null ?
                                                            <VolumeIcon /> :
                                                            <VolumeDisableIcon />
                                                        }
                                                    </IconButton>
                                                </>
                                            }
                                        </Box>
                                    </Box>
                                    {oddStepSevenStore.isProcessing ?
                                        <Box display={"flex"} justifyContent={"flex-end"} >
                                            <Box className={clsx(classes.buttonStyle, classes.complete)}>
                                                <Button disableRipple onClick={handleFinishDivide}>
                                                    <Typography>완료</Typography>
                                                </Button>
                                            </Box>
                                         </Box>
                                        :
                                        <Box display={"flex"} justifyContent={"flex-end"} >
                                            <Box className={clsx(classes.disabled, (oddStepSevenStore.isPositionProcessing ? null : classes.buttonStyle))}>
                                                <Button disableRipple disabled={oddStepSevenStore.isPositionProcessing} onClick={handleClickDivide}>
                                                    <Typography>문장 나누기</Typography>
                                                </Button>
                                            </Box>
                                        </Box>
                                    }

                                    {content && content.pieces.length > 0 &&
                                        <Box className={classes.textContnetScroll}>
                                            <Box className={classes.textContnetBox}>
                                                <Typography>문장 목록</Typography>
                                                {content.pieces.map((piece, index) => {
                                                    const isAudio = (piece.audioStartTime !== undefined && piece.audioStartTime !== null) || piece.audioFileName !== null;
                                                    return (
                                                        <Box key={index} className={classes.textContnet}>
                                                            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                                                <Typography><span>{index + 1}</span>{oddStepSevenStore.getDividedText(piece.textStartIndex, piece.textEndIndex)}</Typography>
                                                                <IconButton className={classes.volumeIcon} disableRipple style={{cursor: isAudio ? 'pointer' : 'default'}} onClick={() => handleClickPieceAudio(`sub-${index}`, piece)} disabled={!isAudio}>
                                                                    {isAudio  ?
                                                                        <VolumeIcon /> :
                                                                        <VolumeDisableIcon />
                                                                    }
                                                                </IconButton>
                                                            </Box>
                                                        </Box>
                                                    )})}
                                            </Box>
                                            <Box display={"flex"} justifyContent={"flex-end"} >
                                                <Box className={clsx(classes.disabled, (oddStepSevenStore.isProcessing || oddStepSevenStore.isPositionProcessing ? null : classes.buttonStyle))} sx={{marginLeft: 10}}>
                                                    <Button disableRipple disabled={oddStepSevenStore.isProcessing || oddStepSevenStore.isPositionProcessing } onClick={() => handleClickGenerateSound()}>
                                                        <Typography>사운드 생성</Typography>
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    }
                                </TabPanel>
                            )})}
                        {oddStepSevenStore.contentList &&
                            <AudioPlayer audio={selectedContent.audio} regionCount={selectedContent.pieces.length} close={handleCloseGenerateSound} callback={handleFinishGenerateSound}/>
                        }
                    </Box>
                    <Popover
                        id={id}
                        open={oddStepSevenStore.popoverState === null ? false : oddStepSevenStore.popoverState}
                        anchorEl={anchorEl}
                        onClose={handleClosePopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        className={classes.popoverTooltip}
                    >
                        <Box className={classes.tooltipTop}>
                            <TooltipTipIcon />
                        </Box>
                        <Box display={'flex'} justifyContent={'flex-end'} className={classes.tooltipBtn}>
                            <Button disableRipple onClick={handleClosePopover}>
                                <TooltipClose />
                            </Button>
                        </Box>
                        <Typography className={classes.typography}>1. 문자 사이 공간을 클릭하면 <CheckPointIcon/>표시가 생성되고<br/>해당 표시를
                            기준으로 본문이 나누어 집니다.</Typography>
                        <Typography className={classes.typography}>2. <CheckPointIcon/>표시를 클릭하면 나누기가 취소됩니다.</Typography>
                    </Popover>
                    <Popover
                        id={positionId}
                        open={oddStepSevenStore.positionPopoverState === null ? false : oddStepSevenStore.positionPopoverState}
                        anchorEl={anchorPositionEl}
                        onClose={handleClosePositionPopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        className={classes.popoverTooltip}
                    >
                        <Box className={classes.tooltipTop}>
                            <TooltipTipIcon />
                        </Box>
                        <Box display={'flex'} justifyContent={'flex-end'} className={classes.tooltipBtn}>
                            <Button disableRipple onClick={handleClosePositionPopover}>
                                <TooltipClose />
                            </Button>
                        </Box>
                        <Typography className={classes.typography}>1. 이미지 위를 클릭하여 번호를 생성해 주세요.</Typography>
                        <Typography className={classes.typography}>2. 생성 된 번호를 드래그하여 번호 위치를 변경할 수 있습니다.</Typography>
                        <Typography className={classes.typography}>3. 랜덤 부여를 클릭하면 생성한 번호 외 나머지 번호는 자동으로 생성 됩니다.</Typography>
                    </Popover>
                </Box>
                <Box className={clsx(classes.rightBoxWrap, classes.heightStep1)}>
                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography>순서 생성</Typography>
                        <IconButton className={classes.volumeIcon} disableRipple disabled={!oddStepSevenStore.isPositionProcessing} onClick={handleResetPosition}>
                            {oddStepSevenStore.isPositionProcessing ?
                                <Refresh />
                                :
                                <RefreshDisabled />
                            }
                        </IconButton>
                    </Box>
                    <Box ref={anchorPositionElRef} className={clsx(classes.rightTextBox, classes.imageBox)} aria-describedby={id} variant="contained" color="primary">
                        <Box className={classes.imageContent}>
                            <Box className={classes.imageBackground}>
                                {oddStepSevenStore.isPositionProcessing && oddStepTwoStore.positionList.map((position, index) => {
                                    if (position != null && imageRef.current) {
                                        const displayPosition = getPrevPosition(position.x, position.y);
                                        const x = displayPosition.x;
                                        const y = displayPosition.y;
                                        return (
                                            <Box id={`position-${index}`} key={index} className={classes.imagePrevNumber}
                                                 style={{left: x - 10, top: y - 10, pointerEvents: 'auto'}}
                                                 draggable={true} onDragEnd={handleDrag}>
                                                <Typography style={{color: '#fff'}}>{index + 1}</Typography>
                                            </Box>
                                        )
                                    }
                                    return null;
                                })}
                                {imageRef.current && oddStepSevenStore.isPositionProcessing ? selectedTempContent &&
                                    selectedTempContent.pieces.map((piece, index) => {
                                    if (imageRef.current && piece.imageSequence) {
                                        const position = getPosition(piece.imageSequence);
                                        return (
                                            <Box id={`position-${piece.imageSequence}`} key={index} className={classes.imageNumber} style={{left: position.left, top: position.top, pointerEvents: 'auto'}} draggable={true} onDragEnd={handleDrag}>
                                                <Typography>{index + 1}</Typography>
                                            </Box>
                                        )
                                    }
                                    return null;
                                })
                                :
                                    selectedContent && selectedContent.pieces.map((piece, index) => {
                                    if (imageRef.current && piece.imageSequence) {
                                        const position = getPosition(piece.imageSequence);
                                        return (
                                            <Box id={`position-${piece.imageSequence}`} key={index} className={classes.imageNumber} style={{left: position.left, top: position.top, pointerEvents: 'auto'}} draggable={true} onDragEnd={handleDrag}>
                                                <Typography>{index + 1}</Typography>
                                            </Box>
                                        )
                                    }
                                    return null;
                                })}
                            </Box>
                            {oddStepSevenStore.image === '' ?
                                <img src={NoImage} alt='NoImage'/>
                                :
                                <div className={classes.gridContainer}>
                                    <div className={classes.gridOverlay} />
                                    <img id='image' ref={imageRef} draggable={false} className={classes.image} src={`data:image/png;base64,${oddStepSevenStore.image}`} alt='이미지' onLoad={handleImageLoad} onClick={generatePosition}/>
                                </div>
                            }
                        </Box>
                    </Box>
                    <Box display={"flex"} justifyContent={"flex-end"} >
                        {oddStepSevenStore.isPositionProcessing ?
                            <>
                                <Box className={clsx(classes.disabled, classes.buttonStyle)}>
                                    <Button disableRipple onClick={() => handleClickRandomPosition()}>
                                        <Typography>랜덤 부여</Typography>
                                    </Button>
                                </Box>
                                <Box className={clsx(classes.disabled, (selectedTempContent.pieces.some(piece => piece.imageSequence === null || piece.imageSequence === undefined) ? null : classes.buttonStyle))} sx={{marginLeft: 10}}>
                                    <Button disableRipple onClick={() => handleFinishPosition()} disabled={selectedTempContent.pieces.some(piece => piece.imageSequence === null || piece.imageSequence === undefined)}>
                                        <Typography>완료</Typography>
                                    </Button>
                                </Box>
                            </>
                            :
                            <Box className={clsx(classes.disabled, ((oddStepSevenStore.isProcessing || (selectedContent && selectedContent.pieces.length === 0)) ? null : classes.buttonStyle))}>
                                <Button disableRipple disabled={oddStepSevenStore.isProcessing || (selectedContent && selectedContent.pieces.length === 0)} onClick={() => handleClickGeneratePosition()}>
                                    <Typography>순서 생성</Typography>
                                </Button>
                            </Box>
                        }
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default withRouter(inject('oddStepTwoStore', 'contentStore','oddStepSevenStore','audioPlayerStore')(observer(OddStepSeven)));
